import { useNavigate } from "@tanstack/react-router";

import { HotelAboutCard } from "@/features/hotels/components/hotel/HotelAboutCard";
import { HotelContactDetails } from "@/features/hotels/components/hotel/HotelContactDetails";
import { HotelDetailsCard } from "@/features/hotels/components/hotel/HotelDetailsCard";
import { HotelFacilities } from "@/features/hotels/components/hotel/HotelFacilities";
import { HotelLocationCard } from "@/features/hotels/components/hotel/HotelLocationCard";
import type { HotelData } from "@/features/hotels/types/types";

interface HotelOverviewProps {
  hotel: HotelData;
}

export const HotelOverview = ({ hotel }: HotelOverviewProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-2">
      <HotelDetailsCard
        hotel={hotel}
        onImageTap={() => {
          navigate({
            to: "/hotels/$id/details/images",
            params: { id: hotel.id },
          });
        }}
      />

      <HotelAboutCard hotel={hotel} />

      <HotelLocationCard hotel={hotel} />

      <HotelFacilities hotel={hotel} />

      <HotelContactDetails hotel={hotel} />
    </div>
  );
};
